import Vue from 'vue';
import App from './App.vue';
import './components/global/_global';
import Vuelidate from 'vuelidate';
import AbsoluteUrl from './plugins/absoluteUrl';

Vue.use(Vuelidate);
Vue.use(AbsoluteUrl);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#sign-up');
